// src/mock/admin_mock.ts

export const mockClients = [
  { id: 1, name: '株式会社A (moc)', plan: 'standard', status: 'active', users: 15, contact: '03-1234-5678', lastLogin: '2026-05-01 10:23', chatCount: 120, diagnosisCount: 45, proposalCount: 12, joinedAt: '2025-01-10' },
  { id: 2, name: '株式会社B (moc)', plan: 'test', status: 'active', users: 5, contact: '03-8765-4321', lastLogin: '2026-04-28 14:15', chatCount: 30, diagnosisCount: 10, proposalCount: 3, joinedAt: '2025-03-22' },
  { id: 3, name: '株式会社C (moc)', plan: 'test', status: 'inactive', users: 2, contact: '06-1111-2222', lastLogin: '2026-02-15 09:00', chatCount: 5, diagnosisCount: 1, proposalCount: 0, joinedAt: '2024-11-05' },
  { id: 4, name: '株式会社D (moc)', plan: 'standard', status: 'active', users: 24, contact: '092-333-4444', lastLogin: '2026-05-01 12:45', chatCount: 350, diagnosisCount: 88, proposalCount: 40, joinedAt: '2025-02-14' },
];

export const mockUsers = [
  { id: 101, userName: '山田 太郎 (moc)', companyName: '株式会社A (moc)', plan: 'standard', status: 'active', contact: 'yamada@a.co.jp', lastLogin: '2026-05-01 10:23', chatCount: 40, diagnosisCount: 15, proposalCount: 5, joinedAt: '2025-01-15' },
  { id: 102, userName: '佐藤 花子 (moc)', companyName: '株式会社A (moc)', plan: 'standard', status: 'active', contact: 'sato@a.co.jp', lastLogin: '2026-04-30 18:00', chatCount: 80, diagnosisCount: 30, proposalCount: 7, joinedAt: '2025-01-16' },
  { id: 103, userName: '鈴木 一郎 (moc)', companyName: '株式会社B (moc)', plan: 'test', status: 'active', contact: 'suzuki@b.co.jp', lastLogin: '2026-04-28 14:15', chatCount: 30, diagnosisCount: 10, proposalCount: 3, joinedAt: '2025-03-25' },
  { id: 104, userName: '高橋 次郎 (moc)', companyName: '株式会社D (moc)', plan: 'standard', status: 'active', contact: 'takahashi@d.co.jp', lastLogin: '2026-05-01 12:45', chatCount: 350, diagnosisCount: 88, proposalCount: 40, joinedAt: '2025-02-20' },
];

export const mockPayments = [
  // 2026-05
  { id: 105, clientId: 1, companyName: '株式会社A (moc)', amount: 39800, status: '未決済', date: '2026-05-01' },
  { id: 106, clientId: 2, companyName: '株式会社B (moc)', amount: 39800, status: '銀行振込', date: '2026-05-02' },
  { id: 107, clientId: 3, companyName: '株式会社C (moc)', amount: 39800, status: '決済失敗', date: '2026-05-05' },
  { id: 108, clientId: 4, companyName: '株式会社D (moc)', amount: 39800, status: '未決済', date: '2026-05-03' },
  // 2026-04
  { id: 101, clientId: 1, companyName: '株式会社A (moc)', amount: 39800, status: '決済済', date: '2026-04-01' },
  { id: 102, clientId: 2, companyName: '株式会社B (moc)', amount: 39800, status: '決済済', date: '2026-04-01' },
  { id: 103, clientId: 3, companyName: '株式会社C (moc)', amount: 39800, status: '決済失敗', date: '2026-04-05' },
  { id: 104, clientId: 4, companyName: '株式会社D (moc)', amount: 39800, status: '決済済', date: '2026-04-03' },
  // 2026-03
  { id: 97, clientId: 1, companyName: '株式会社A (moc)', amount: 39800, status: '決済済', date: '2026-03-01' },
  { id: 98, clientId: 2, companyName: '株式会社B (moc)', amount: 39800, status: '決済済', date: '2026-03-01' },
  { id: 99, clientId: 3, companyName: '株式会社C (moc)', amount: 39800, status: '決済済', date: '2026-03-05' },
  { id: 100, clientId: 4, companyName: '株式会社D (moc)', amount: 39800, status: '決済済', date: '2026-03-02' },
];

export const mockInquiries = [
  { id: 1001, userName: '山田 太郎 (moc)', company: '株式会社A (moc)', title: 'AI診断の使い方について', status: 'open', date: '2026-04-28' },
  { id: 1002, userName: '佐藤 花子 (moc)', company: '株式会社B (moc)', title: '決済エラーが発生しました', status: 'resolved', date: '2026-04-25' },
  { id: 1003, userName: '鈴木 一郎 (moc)', company: '株式会社C (moc)', title: '新機能の要望', status: 'open', date: '2026-04-29' },
];

export const mockClientDetails: Record<number, any> = {
  1: {
    id: 1,
    name: '株式会社A (moc)',
    plan: 'standard',
    status: 'active',
    contact: '03-1234-5678',
    joinedAt: '2025-01-10',
    companyInfo: {
      representative: '田中 太郎',
      corporateNumber: '1234567890123',
      postalCode: '150-0043',
      address: '東京都渋谷区道玄坂1-1-1',
      industry: 'IT / Webサービス',
    },
    metrics: {
      monthlyLogins: 45,
      chatCount: 120,
      diagnosisCount: 45,
      proposalExecutionCount: 12,
    },
    salesInfo: {
      hearingStatus: '実施済',
      hearingDate: '2026-04-10',
      brand: '自社コスメブランド',
      monthlyBudget: '2000000',
      platforms: ['Google Ads', 'Meta Ads', 'LINE広告'],
      knowledgeLevel: '中',
      targetCTR: '1.2',
      targetCVR: '2.5',
      agencyNeeds: 'あり',
      memo: 'インハウス運用に限界を感じており、AIによる自動化と代理店サポートの両方を検討している。'
    },
    platforms: ['Google', 'Meta', 'Yahoo', 'Google Analytics(GA4)', 'OpenAI'],
    budgetHistory: {
      months: ['1月', '2月', '3月', '4月', '5月'],
      google: [100000, 120000, 110000, 150000, 180000],
      meta: [50000, 60000, 70000, 65000, 80000],
      yahoo: [30000, 30000, 40000, 45000, 50000],
    },
    users: [
      { id: 101, userName: '山田 太郎 (moc)', role: 'Admin', lastLogin: '2026-05-01 10:23', status: 'active' },
      { id: 102, userName: '佐藤 花子 (moc)', role: 'User', lastLogin: '2026-04-30 18:00', status: 'active' },
    ],
    chats: [
      { id: 1, user: '山田 太郎 (moc)', message: '競合分析のレポートを作成して', date: '2026-05-01 09:15' },
      { id: 2, user: '佐藤 花子 (moc)', message: '新しいキャンペーンのキャッチコピー案', date: '2026-04-30 14:20' },
    ],
    payments: [
      { id: 101, amount: 50000, status: 'paid', date: '2026-04-01' },
      { id: 98, amount: 50000, status: 'paid', date: '2026-03-01' },
    ],
    memos: [
      { id: 1, text: '次回更新時にプランアップグレードの打診を行う。', date: '2026-04-15' },
      { id: 2, text: 'Meta広告のアカウント再設定が必要。', date: '2026-04-20' },
    ]
  }
};

export const mockRegistrations = [
  { id: 501, companyName: '株式会社エックス (moc)', userName: '高橋 健太 (moc)', email: 'takahashi@x.co.jp', phone: '03-9999-8888', role: '広告主', budget: '100万円〜500万円', date: '2026-05-01', status: '未対応' },
  { id: 502, companyName: 'ワイエージェンシー (moc)', userName: '伊藤 美咲 (moc)', email: 'ito@y-agency.com', phone: '06-7777-6666', role: '代理店', budget: '500万円以上', date: '2026-04-30', status: '対応中' },
  { id: 503, companyName: 'ゼットクリエイティブ (moc)', userName: '渡辺 剛 (moc)', email: 'watanabe@z-creative.net', phone: '092-555-4444', role: '制作会社', budget: '未定', date: '2026-04-28', status: '完了' },
];

export const mockRegistrationDetails: Record<number, any> = {
  501: {
    id: 501,
    companyName: '株式会社エックス (moc)',
    userName: '高橋 健太 (moc)',
    email: 'takahashi@x.co.jp',
    phone: '03-9999-8888',
    role: '広告主',
    budget: '100万円〜500万円',
    date: '2026-05-01',
    status: '未対応',
    notes: '新規事業のプロモーションのため、AIを活用した診断と競合調査を行いたい。まずはトライアルでの利用を検討している。',
    salesInfo: {
      hearingStatus: '未済',
      hearingDate: '',
      brand: '',
      monthlyBudget: '',
      platforms: [] as string[],
      knowledgeLevel: 'なし',
      targetCTR: '',
      targetCVR: '',
      agencyNeeds: '検討',
      memo: ''
    }
  }
};
